import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TonalButtonMedium = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Tonal Medium button"}
        value={
          "<Button variant={'tonal'} color={\"secondary\"}>Medium</Button>"
        }
      >
        <Button variant={"tonal"} color={"secondary"}>
          Medium
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TonalButtonMedium;
